import React from "react"

const Footer = () => {
    return (
        <footer className="text-sm text-center mt-12 pb-4 md:pb-12">
            <div className="mt-6 md:mt-0">
                {/* <nav>
                    <a className="mr-6" href="#">Register</a>
                    <a className="mr-6" href="#">Sign in</a>
                </nav> */}
            </div>
            <div className="mt-4">
                <p>© 2020 Created by Nik Danilov</p>
            </div>
        </footer>
    )
}

export default Footer